import type { MeterBarChartThresholdProps } from '../types/meter-bar-chart.js';

export const Threshold = (props: MeterBarChartThresholdProps) => null;

Threshold['displayName'] = 'MeterBarChart.Threshold';
